export default __webpack_public_path__ + "static/media/mrw.476e696d.svg";